import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MultiaccountsPage } from './multiaccounts';

@NgModule({
  declarations: [
    MultiaccountsPage,
  ],
  imports: [
    IonicPageModule.forChild(MultiaccountsPage),
  ],
})
export class MultiaccountsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/multiaccounts/multiaccounts.module.ts